import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '@shared/shared.module';
import { MatCoreModule } from '@shared/material/mat-core.module'


@NgModule({
  declarations: [DashboardComponent ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    MatCoreModule
  ]
})
export class DashboardModule { }
